import React, { useContext, useLayoutEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/reducers";
import { AuthProvider } from "./auth/AuthContext";
import ApiInit from "./app/models/ApiInit";
import Messages, { ContextMessages } from "./view/modules/app/messages";
import AppInit from "./AppInit";
import PagesRouter from "./view/pages";

// Мост UI → модели: даёт ApiInit доступ к тостам (addMessages из моделей).
function AppContextBridge() {
    const contextMessages = useContext(ContextMessages);
    useLayoutEffect(() => {
        ApiInit.contextApp = { messages: contextMessages };
    }, [contextMessages]);
    return null;
}

export default function App() {
    return <Provider store={store}>
        <AuthProvider>
            <Messages>
                <AppContextBridge/>
                <BrowserRouter>
                    <AppInit>
                        <PagesRouter/>
                    </AppInit>
                </BrowserRouter>
            </Messages>
        </AuthProvider>
    </Provider>;
}
